module.exports = __webpack_public_path__ + "img/82ne.2307e9ed.svg";